import React, { useEffect, useState } from "react";
import EmployeeNavbar from "./EmployeeNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function AllResignationRequests() {
    const ID = Cookies.get("log_id");
    const [resignations,setResignations] = useState([]);
    function AllResignations() {
        axios.get(`${url.path}/all_resignations_requests/`,{
            params:{
                id:ID
            }
        })
        .then((res) =>{
            if(res.data.status){
                var rsg = res.data.resignations;
                setResignations([])
                rsg.map((r)=>{
                    setResignations((prevState)=>[
                        ...prevState, r
                    ])
                })
            }
        }).catch((err)=>{
            console.log('ERROR',err)
          })
    }
    useEffect(()=>{
        AllResignations();
    },[])
    const itemsPerPage = 3;
          const [searchTerm, setSearchTerm] = useState("");
          const [currentPage, setCurrentPage] = useState(0);
    
          const filteredData = resignations.filter((item) =>
            item.Employee_Name.toLowerCase().includes(searchTerm.toLowerCase())
          );
    
          const offset = currentPage * itemsPerPage;
          const currentItems = filteredData.slice(offset, offset + itemsPerPage);
          const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    
          const handlePageClick = ({ selected }) => {
            setCurrentPage(selected);
          };
          function searchTable(){
            var rows = document.querySelectorAll('#companytable tbody tr');
            var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
            rows.forEach(function(row) {
              var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
              row.style.display = text.includes(val) ? '' : 'none';
            });
          }
    return(
        <>
        <EmployeeNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Resignation</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
            
            
      {/* <input
        type="text"
        placeholder="Search..."
        onKeyUp={searchTable}
        className="search-input"
        id="search"
      /> */}
      <table className="responsive-table" id="companytable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Reason</th>
            <th>Notice Period</th>
            <th>Status</th>
            <th>Rejection Reason</th>
          </tr>
        </thead>
        <tbody>
          {resignations.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Employee_Name}</td>
              <td>{i.Reason_For_Resignation}</td>
              <td>{i.Notice_Period}days</td>
              <td>{i.Status}</td>
              <td>{i.Rejection_Reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllResignationRequests;